<template>
   <!-- <div  
    class="card chat-window shadow-lg border-0"> -->
    <div class="card-header bg-dark text-white d-flex align-items-center justify-content-between py-3">
      <div class="d-flex align-items-center">
        <div class="bot-icon bg-danger rounded-circle d-flex align-items-center justify-content-center mr-2">
          <i class="fas fa-robot text-white"></i>
        </div>
        <div>
          <h6 class="mb-1 font-weight-bold" style="font-size: 0.85rem;">Flightline AI</h6>
          <small class="text-success d-flex align-items-center" style="font-size: 0.65rem;">
            <span class="dot mr-1"></span> Online & Ready
          </small>
        </div>
      </div>
      <div class="header-actions">
        <button v-if="$route.path !== '/search-bot'"  
        class="btn btn-link text-muted p-1 mr-1" 
        @click="expandChatPage">
          <svg data-v-c1cad5e6="" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-maximize2-icon lucide-maximize-2" aria-hidden="true"><path d="M15 3h6v6"></path><path d="m21 3-7 7"></path><path d="m3 21 7-7"></path><path d="M9 21H3v-6"></path></svg>
        </button>
        <button class="btn btn-link text-muted p-1 mr-1" 
          @click="clearChat">
            <svg data-v-c1cad5e6="" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-message-square-plus-icon lucide-message-square-plus" aria-hidden="true"><path d="M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z"></path><path d="M12 8v6"></path><path d="M9 11h6"></path></svg>
          </button>
        <button class="btn btn-link text-muted p-1"
         @click="toggleChat">
          <i class="fas fa-times"></i>
        </button>
      </div>
    </div>

    <div ref="chatContainer" class="card-body overflow-auto p-3" style="height: 380px;background-color: #F9FAFB;">
      <div class="d-flex flex-column align-items-start mb-3">
        <div class="message-bubble bot shadow-sm mb-2">
          Hello! I’m your Flightline procurement assistant.  What can I help you with today?
        </div>
        <div
          v-for="(msg, index) in messages"
          :key="index"
          :class="[
            'message-bubble shadow-sm mb-2',
            msg.type,
            { 'text-danger': msg.messageType === 'error' }
          ]"
          
        >
          {{ msg.text }}


          <!-- Products -->
          <template v-if="msg.contentType==='products'">
          
            <div 
              v-for=" product in msg.products"
              :key="product.asin"
              class="card product-card shadow-sm border-light mb-4 cursor-pointer" 
              style="border-radius: 12px; overflow: hidden;"
              @click.prevent="goToDetails(product.asin)">
    
                <div class="card-img-top bg-light d-flex align-items-center justify-content-center" style="height: 128px; padding: 1rem;">
                    <img :src="product.imageUrl" 
                        class="img-fluid h-100 hover-zoom" 
                        style="object-fit: contain; mix-blend-mode: multiply;" 
                        :alt="product.title">
                </div>

                <div class="card-body p-3">
                  
                    <p class="text-primary font-weight-bold text-uppercase mb-1" style="font-size: 13px; letter-spacing: 0.5px;">
                        {{product.asin}}
                    </p>
                    
                    <h6 class="card-title font-weight-bold text-dark text-truncate mb-3" style="font-size: 0.875rem;">
                        {{product.title}}
                    </h6>

                    <div class="d-flex align-items-center justify-content-between"
                     v-for="offer in product.offers"
                      :key="offer.id">
                        <span class="h6 mb-0 font-weight-bold text-primary">${{offer.price?.value?.amount}}</span>
                        
                        <button 
                        @click.stop="handleAddToCart(product, offer)"
                        :disabled="btnloading"
                        class="btn btn-primary btn-sm d-flex align-items-center rounded-lg shadow-blue" style="padding: 0.4rem 0.75rem; font-size: 14px;">
                        <i v-if='btnloading && offer.offerId==offer_id' class="fa fa-spinner fa-spin mr-2" aria-hidden="true"></i>
                        <i v-else class="fas fa-shopping-cart mr-2"></i>
                            Add to Cart
                        </button>
                    </div>
                </div>
            </div>
            <button 
             v-if="msg.products.length"
             type="button"
             @click="openSearchPage()"
             class="btn btn-block d-flex align-items-center justify-content-center text-primary font-weight-bold border-dashed rounded-lg py-2 cursor-pointer" 
                    style="font-size: 13px; border: 1px dashed #c1d4fd; background: transparent; transition: all 0.2s;"
                    onmouseover="this.style.backgroundColor='#f0f7ff'; this.style.color='#0056b3';"
                    onmouseout="this.style.backgroundColor='transparent'; this.style.color='#007bff';">
              <span class="mr-2">See all recommendations</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chevron-right" aria-hidden="true">
                <path d="m9 18 6-6-6-6"></path>
              </svg>
            </button>
          </template>



        </div>



        <!-- Loader -->
        <div v-if="loading" class="d-flex align-items-center bg-white p-3 border border-light shadow-sm" 
            style="border-radius: 1rem; border-top-left-radius: 0; width: fit-content;">
            
            <div class="spinner-border spinner-border-sm text-muted mr-2" role="status" style="width: 1rem; height: 1rem;">
                <span class="sr-only">Loading...</span>
            </div>
            
            <span class="small text-muted font-italic">Thinking...</span>
        </div>
      </div>
    </div>

    <div class="card-footer bg-white border-top-0 p-3">
      <div class="input-group">
        <input type="text" 
        ref="message_input"
        v-model="messageInput"
        @keyup.enter="sendMessage"
        class="form-control border-0 bg-light rounded-pill px-3" placeholder="Ask about our products..." style="font-size: 0.85rem;"
        :disabled="loading">
        <div class="input-group-append ml-2">
          <button class="btn btn-primary rounded-lg" type="button"
          :disabled="!messageInput || loading"
          @click="sendMessage()">
            <i class="fas fa-paper-plane"></i>
          </button>
        </div>
      </div>
      <p class="text-center text-muted mt-2 mb-0" style="font-size: 9px;">
          AI generated responses. Prices and availability subject to change.
      </p>
    </div>
  <!-- </div> -->
</template>

<script setup>
import { computed, ref, defineEmits, nextTick, onMounted } from 'vue'
import { useStore } from 'vuex'
import { useRouter, useRoute } from 'vue-router'


const router = useRouter()
const route = useRoute()

const store = useStore()

const chatContainer = ref(null)
const message_input = ref(null)

const messageInput = ref('')
const btnloading = ref(false)
const offer_id = ref(0)
const emit = defineEmits(['toggleChat'])

const toggleChat = () => {
  emit('toggleChat')
}

const expandChatPage = () => {
  router.push('/search-bot')
}

const messages = computed(() => store.getters['searchBot/messages'])
const loading = computed(() => store.getters['searchBot/loading'])
const lastSearchQuery = computed(() => store.getters['searchBot/lastSearchQuery'])
const searchRefinements = computed(() => store.getters['searchBot/searchRefinements'])


const sendMessage = async () => {
  store.dispatch('searchBot/sendMessage', { message: messageInput.value })
  messageInput.value = ''
  message_input.value.focus()
  scrollToBottom()
}
const clearChat = () => {
  store.dispatch('searchBot/clearChat')
}

const scrollToBottom = async () => {
  await nextTick() // Wait for the DOM to update after data changes
  if (chatContainer.value) {
    chatContainer.value.scrollTop = chatContainer.value.scrollHeight
  }
}

function handleAddToCart (item, offer) {
  if (!item || !offer) return

  offer_id.value = offer.offerId
  let payload = {
    asin: item.asin,
    quantity: 1,
    offer_id: offer.offerId
  }
  payload.attributes= {
    id: item.id || item.asin || `${item.title}-${offer.id}`,
    offerId: offer.offerId,
    title: item.title,
    manufacturer: item.manufacturer,
    imageUrl: item.imageUrl,
    price: offer.price?.value?.amount ?? item.price,
    seller: offer.merchant?.name,
    fulfiller: offer.fulfiller?.name,
    quantityLimits: offer.quantityLimits
  }
  addToCart( payload )
}

const addToCart = async (payload) => {
  btnloading.value = true
  await store.dispatch('cart/addToCart', {
    ...payload
  })
  btnloading.value = false
  offer_id.value = 0

}

function goToDetails (asin) {
	window.open(`/product/${asin}`, '_blank')
}

function openSearchPage () {

  let filterValues = lastSearchQuery.value?.searchRefinements?.split(',') ?? []
  const filteredResults = filterValues.filter(value => {
    // فحص ما إذا كان أي عنصر في refinementValues يطابق أكواد الفلترة
    return searchRefinements.value.find(val => {

      let filterValue = val.refinementValues.find(filter => filter.searchRefinementValue === value)
      if (val?.selectionType=='MultiSelectOR' && filterValue) {
        return true
      }
    });
  });
  let single = {}

  filterValues.forEach(value => {
    // فحص ما إذا كان أي عنصر في refinementValues يطابق أكواد الفلترة
    return searchRefinements.value.find(val => {
      let filterValue = val.refinementValues.find(filter => filter.searchRefinementValue === value)
    
      if (val?.selectionType=='InsteadSelect' && filterValue) {
        single[val.displayValue] = filterValue.searchRefinementValue
      }
    });
  });

  
  let query = {
    keywords: lastSearchQuery.value.keywords,
    sortKey: lastSearchQuery.value.sortKey || 'RELEVANCE',
    pageNumber: lastSearchQuery.value.pageNumber || 0,
    selected: filteredResults?.join(','),
    single: encodeURIComponent(JSON.stringify(single)),
    searchRefinements: lastSearchQuery.value.searchRefinements,
    searchNumber: 0
  }
  if (route.path === '/search') {
    let searchNumber = route.query.searchNumber || 0
    query.searchNumber= Number(searchNumber) + 1 
    router.replace({
      path: '/search',
      query: query,
    })
  } else {
    query.searchNumber = 0
    router.push({
      path: '/search',
      query: query,
    })
  }


onMounted(() => {
  message_input.value.focus()
})
}


</script>

<style scoped>
.chat-btn {
  transition: all 0.2s ease;
}

.chat-btn:hover {
  background-color: #c82333 !important;
}

.chat-btn:active {
  transform: scale(0.9);
}
/* Positioning the window */
.chat-window {
    position: fixed;
    bottom: 100px;
    right: 24px;
    width: 380px;
    height: 550px;
    border-radius: 1rem !important;
    z-index: 1050;
}

/* Floating Red Button */
.btn-floating {
    position: fixed;
    bottom: 24px;
    right: 24px;
    width: 56px;
    height: 56px;
    z-index: 1050;
    font-size: 20px;
}

/* Custom Message Bubble Styling */
.message-bubble {
    max-width: 85%;
    font-size: 0.85rem;
    border-radius: 1rem;
    border-top-left-radius: 0;
    border: 1px solid #f0f0f0;
    padding: 0.75rem;
}

/* Bot Icon sizing */
.bot-icon {
    width: 32px;
    height: 32px;
}

/* Pulse animation for the online dot */
.dot {
    height: 6px;
    width: 6px;
    background-color: #28a745;
    border-radius: 50%;
    display: inline-block;
    animation: pulse 1.5s infinite;
}

@keyframes pulse {
    0% { opacity: 1; }
    50% { opacity: 0.4; }
    100% { opacity: 1; }
}

.user {
  text-align: right;
  margin-left: auto;
  border-top-right-radius: 0;
  border-top-left-radius: 1rem !important;
  background: #1F7FBA  !important;
  color: #fff !important;
}

.bot {
  background: #fff;
}
/* Zoom effect on image hover */
.product-card:hover .hover-zoom {
    transform: scale(1.1);
    transition: transform 0.3s ease;
}

.hover-zoom {
    transition: transform 0.3s ease;
}

/* Custom shadow for the blue button to match Tailwind's shadow-blue-500/20 */
.shadow-blue {
    box-shadow: 0 4px 6px -1px rgba(59, 130, 246, 0.2), 0 2px 4px -1px rgba(59, 130, 246, 0.1);
}

/* Smooth entry animation like Tailwind's animate-in */
.product-card {
    animation: slideInUp 0.3s ease-out;
}

@keyframes slideInUp {
    from { transform: translateY(8px); opacity: 0; }
    to { transform: translateY(0); opacity: 1; }
}

.card-body {
  scroll-behavior: smooth;
}
.cursor-pointer {
  cursor: pointer;
}
input[disabled],
button[disabled] {
  cursor: not-allowed;
}
</style>
